var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row animated fadeIn slow"},[_c('transition',{attrs:{"name":"fade"}},[_c('event-list',{attrs:{"events":_vm.events || []}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }